import { useMetaTags } from './useMetaTags';
import {useTranslation} from 'react-i18next';

function pickFirstNonEmpty(...values) {
    for (let i = 0; i < values.length; i += 1) {
        const value = values[i];
        if (value === null || typeof value === 'undefined') {
            continue;
        }

        const normalized = String(value).trim();
        if (normalized) {
            return normalized;
        }
    }

    return '';
}

function normalizeMetaItems(items) {
    if (!Array.isArray(items)) {
        return [];
    }

    return items.filter((item) => item && typeof item === 'object');
}

export default function usePageMeta({
    title,
    description,
    keywords,
    metas = [],
} = {}) {
    const {t} = useTranslation();

    const resolvedTitle = pickFirstNonEmpty(title, t('app.title'));
    const resolvedDescription = pickFirstNonEmpty(description, t('app.description'));
    const resolvedKeywords = pickFirstNonEmpty(keywords, t('app.keywords'));
    const resolvedMetas = normalizeMetaItems(metas).filter((item) => item?.name !== 'keywords');

    useMetaTags({
        title: resolvedTitle,
        description: resolvedDescription,
        metas: [
            {name: 'keywords', content: resolvedKeywords},
            ...resolvedMetas,
        ],
    });
}
